import { TitleFieldProps } from "@rjsf/utils";
import { Title, TitleProps } from "../../Common/Typography";
import { HeaderWrapper } from "./__styles__/TitleFieldTemplate";

// NOTE: The`isInGroup` prop is temporary. See `ObjectFieldTemplate` for
// context on why we added it.
export interface TitleFieldTemplateProps extends TitleFieldProps {
  isInGroup?: boolean;
}

export const TitleFieldTemplate = (props: TitleFieldTemplateProps) => {
  const { id, title, uiSchema, isInGroup } = props;
  const size = uiSchema?.["ui:heading"] === "h1" ? "large" : "default";

  const headingProps: Pick<TitleProps, "size" | "type"> = {
    size: isInGroup ? "small" : size,
    type: isInGroup ? "semiBold" : "regular",
  };

  const wrapperSize = isInGroup ? "default" : size;

  return (
    <HeaderWrapper size={wrapperSize}>
      <Title id={id} {...headingProps}>
        {title}
      </Title>
    </HeaderWrapper>
  );
};
